import { createBrowserRouter } from "react-router-dom";

import { ArchiveRoutes } from "@/components/Routes/ArchiveRoutes";
import { CommonRoutes } from "@/components/Routes/CommonRoutes";
import { CompetencyRoutes } from "@/components/Routes/CompetencyRoutes";
import { ErrorRoutes } from "@/components/Routes/ErrorRoutes";
import { GroupsRoutes } from "@/components/Routes/GroupsRoutes";
import { JobRoutes } from "@/components/Routes/JobRoutes";
import { LiveRoutes } from "@/components/Routes/LiveRoutes";
import { MaterialHandlingRoutes } from "@/components/Routes/MaterialHandlingRoutes";
import { NodeDiagramRoutes } from "@/components/Routes/NodeDiagramRoutes";
import { ProcedureRoutes } from "@/components/Routes/ProcedureRoutes";
import { SettingsRoutes } from "@/components/Routes/SettingsRoutes";
import { ShiftRoutes } from "@/components/Routes/ShiftRoutes";
import { TasksRoutes } from "@/components/Routes/TaskRoutes";
import { TrainingRoutes } from "@/components/Routes/TrainingRoutes";
import { ProfileRoutes } from "@/components/Routes/ProfileRoutes";
import { UserRoutes } from "@/components/Routes/UserRoutes";
import { MeasurementsRoutes } from "@/components/Routes/MeasurementRoutes";
import { LabRoutes } from "@/components/Routes/LabRoutes";
import { EducationRoutes } from "@/components/Routes/EducationRoutes";

export const router = createBrowserRouter([
	{
		path: "/",
		lazy: async () => {
			const { Layout } = await import("@/components/Application/Layout");
			return { Component: Layout };
		},
		children: [
			{
				index: true,
				lazy: async () => {
					const { Dashboard } = await import(
						"@/components/Application/Dashboard"
					);
					return { Component: Dashboard };
				},
			},
			...ProcedureRoutes,
			...CommonRoutes,
			ArchiveRoutes,
			MaterialHandlingRoutes,
			NodeDiagramRoutes,
			TasksRoutes,
			ErrorRoutes,
			LiveRoutes,
			CompetencyRoutes,
			ShiftRoutes,
			LabRoutes,
			UserRoutes,
			JobRoutes,
			EducationRoutes,
			SettingsRoutes,
			TrainingRoutes,
			GroupsRoutes,
			ProfileRoutes,
			MeasurementsRoutes,
		],
	},
]);
